import React from 'react';
import { withRouter } from 'react-router-dom';
import { Link, matchPath } from 'react-router-dom';

import COMPS_COLORS from 'constants/colors';
import { Text } from '@cuemath/web-comps';
import styled from 'styled-components';
import ArrowSeperatorIcon from 'img/top-bar/bread-crumbs-arrow.svg';
import { BREADCRUMBS } from './breadcrumbs-list';
import { Row } from '@cuemath/comps';

const BreadcrumbText = styled(Text)`
  text-transform: capitalize;
`;

const BreadcrumbExampleShorthand = props => {
  const {
    location: { pathname },
    history,
  } = props;

  function getContent(isLink, path, route, action) {
    let breadCrumbName = null;

    if (path === null) {
      const { name } = action() || {};
      breadCrumbName = name || '-';
    } else {
      breadCrumbName = path?.replaceAll('-', ' ');
    }

    if (isLink) {
      return (
        <>
          <Link onClick={() => history.push(route.replace('*', ''))}>
            <BreadcrumbText variant="body3" color={COMPS_COLORS.FONT}>
              {breadCrumbName}
            </BreadcrumbText>
          </Link>
          <img src={ArrowSeperatorIcon} alt="arrow" />
        </>
      );
    }

    return (
      <BreadcrumbText variant="body3" color={COMPS_COLORS.ABBEY}>
        {breadCrumbName}
      </BreadcrumbText>
    );
  }

  function getMatchingPath() {
    const matchingPaths = BREADCRUMBS?.filter(breadcrumb => {
      const isMaching = matchPath(pathname, {
        path: breadcrumb.pathName,
        exact: true,
        strict: false,
      });

      if (isMaching) {
        return breadcrumb;
      }
      return null;
    });

    return matchingPaths?.map((breadcrumb, index) => {
      return (
        <Row key={index}>
          {getContent(
            index < matchingPaths.length - 1,
            breadcrumb.name,
            breadcrumb.pathName,
            breadcrumb.action,
          )}
        </Row>
      );
    });
  }

  return <>{getMatchingPath()}</>;
};

export default withRouter(BreadcrumbExampleShorthand);
